import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastManagerProp, withToastManager } from 'react-toast-notifications';

import { LoaderSpinner } from 'components/UtilElements';
import * as dt from 'core/datetime';
import { apiErrorHandler } from 'core/errors';
import { DATE_FORMAT } from 'globals/constants';
import { Dispatch } from 'redux';
import { UPDATE_SIGNEDUP_FACULTY_ACCOUNTS } from 'redux/actions';
import { API, getCancelToken, request } from 'redux/api';
import { pluralize } from 'utils';

interface GetAdminAccountsResponse {
  message: string;
  users: SignedUpUser[];
}

interface FacultyAccountProps extends ToastManagerProp {
  updateSignedUpFacultyAccounts(accoutns: SignedUpUser[]): Promise<void>;
}

interface FacultyAccountState {
  loading: boolean;
  facultyAccounts: {
    signedUpUsers: SignedUpUser[];
  };
}

class FacultyAccount extends Component<FacultyAccountProps, FacultyAccountState> {
  apiSources = getCancelToken();

  state: FacultyAccountState = {
    loading: true,
    facultyAccounts: {
      signedUpUsers: [],
    },
  };

  async getAdminAccounts() {
    const response = await request<GetAdminAccountsResponse>({
      url: API.SIGNED_UP_FACULTIES,
      cancelToken: this.apiSources.token,
    });
    return response.users;
  }

  async componentDidMount() {
    this.apiSources = getCancelToken();
    try {
      const accounts = await this.getAdminAccounts();
      this.props.updateSignedUpFacultyAccounts(accounts);
      this.setState({
        loading: false,
        facultyAccounts: {
          ...this.state.facultyAccounts,
          signedUpUsers: accounts,
        },
      });
    } catch (err) {
      apiErrorHandler(this.props.toastManager, err, () => {
        this.setState({ loading: false });
      });
    }
  }

  componentWillUnmount() {
    this.apiSources.cancel();
  }

  getTable = () => {
    const { signedUpUsers } = this.state.facultyAccounts;
    const { loading } = this.state;

    if (loading) {
      return (
        <div className='loader-wrapper'>
          <LoaderSpinner />
        </div>
      );
    }

    return (
      <table className='table table--bordered'>
        <tbody>
          {signedUpUsers.map((account) => (
            <tr key={account.userId}>
              <td className='table__cell'>
                <div className='table__cell-header table__cell-header--title'>{account.name}</div>
                <div className='table__cell-value'>{account.emailId}</div>
              </td>
              <td className='table__cell'>
                <div className='table__cell-header'>JOINED ON</div>
                <div className='table__cell-value table__cell-value--no-wrap'>
                  {account.joinedOn > 0 ? dt.format(account.joinedOn, DATE_FORMAT) : '--'}
                </div>
              </td>
              <td className='table__cell'>
                <div className='table__cell-header'>COURSES ON ACADLY</div>
                <div className='table__cell-value'>{account.courses.length}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    const { loading } = this.state;
    const { signedUpUsers } = this.state.facultyAccounts;

    return (
      <div className='section'>
        <div className='section__header'>
          <h3 className='section__title'>
            {loading
              ? 'Loading faculties...'
              : signedUpUsers.length
              ? `${signedUpUsers.length} faculty ${pluralize(signedUpUsers.length, 'member')} on Acadly`
              : 'No faculty members have signed up for Acadly yet'}
          </h3>
        </div>
        <div className='section__body'>{this.getTable()}</div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateSignedUpFacultyAccounts: async (data: SignedUpUser[]) => {
    dispatch({
      type: UPDATE_SIGNEDUP_FACULTY_ACCOUNTS,
      payload: data,
    });
  },
});

export default connect(null, mapDispatchToProps)(withToastManager(FacultyAccount));
